import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useMe } from '@/hooks/use-me';

export const Route = createFileRoute('/_authenticated/admin')({
  component: AdminGuard,
});

function AdminGuard() {
  const { data: me } = useMe();
  if (me && me.member.role !== 'admin') {
    return (
      <div className="mx-auto max-w-2xl px-6 py-20 text-center">
        <h1 className="mb-2 text-xl font-semibold">Admin access required</h1>
        <p className="text-sm text-text-muted">
          Ask another admin to grant you the <code>admin</code> role.
        </p>
      </div>
    );
  }
  return <Outlet />;
}
